<button
  [type]="type"
  class="app-btn"
  [ngClass]="['variant-' + variant, 'size-' + size, fullWidth ? 'full-width' : '']"
  [disabled]="disabled || loading"
  (click)="onClick($event)"
>
  <span class="spinner" *ngIf="loading" aria-hidden="true"></span>
  <ng-content></ng-content>
</button>
